import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import {
  StrapiStepDTO,
  StepDTO,
} from "@lib/strapi/dtos/components/shared/step.dto";
import { MDXRemoteSerializeResult } from "next-mdx-remote";

export interface StrapiStepsSectionDTO extends StrapiDynamicZoneComponentDTO {
  heading: string;
  intro: string;
  steps: StrapiStepDTO[];
}

export class StepsSectionDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  heading: string;
  intro: MDXRemoteSerializeResult;
  steps: StepDTO[];
}
